import produce from 'immer';

const estadoInicial = {
  tokenLoja: null,
  tokenPainel: null,
  tokenPainelRelatorio: null,
  autenticadoLoja: false,
  autenticadoPainel: false,
  autenticadoPainelRelatorio: false,
  autenticandoLoja: false,
  autenticandoPainel: false,
  autenticandoPainelRelatorio: false,
  redesAntifraude: [],
};

export default function autenticacao(state = estadoInicial, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@autenticacao/DESAUTENTICAR': {
        draft.tokenPainel = null;
        draft.autenticadoPainel = false;
        draft.tokenLoja = null;
        draft.autenticadoLoja = false;
        draft.tokenPainelRelatorio = null;
        draft.autenticadoPainelRelatorio = false;
        sessionStorage.clear();
        break;
      }
      case '@autenticacaoUsuario/AUTENTICAR': {
        draft.autenticandoPainel = true;
        break;
      }
      case '@autenticacaoUsuario/DESAUTENTICAR': {
        draft.tokenPainel = null;
        draft.autenticadoPainel = false;
        break;
      }
      case '@autenticacaoUsuario/AUTENTICAR_SUCESSO': {
        draft.tokenPainel = action.payload.tokenPainel;
        draft.autenticadoPainel = true;
        draft.autenticandoPainel = false;
        break;
      }
      case '@autenticacaoUsuario/AUTENTICAR_FALHOU': {
        draft.autenticandoPainel = false;
        break;
      }
      case '@autenticacaoParceiro/AUTENTICAR': {
        draft.autenticandoLoja = true;
        break;
      }
      case '@autenticacaoParceiro/DESAUTENTICAR': {
        draft.tokenLoja = null;
        draft.autenticadoLoja = false;
        break;
      }
      case '@autenticacaoParceiro/AUTENTICAR_SUCESSO': {
        draft.tokenLoja = action.payload.tokenLoja;
        draft.autenticadoLoja = true;
        draft.autenticandoLoja = false;
        break;
      }
      case '@autenticacaoParceiro/AUTENTICAR_FALHOU': {
        draft.autenticandoLoja = false;
        break;
      }
      case '@autenticacaoUsuario/ATUALIZAR_ANTIFRAUDE': {
        draft.redesAntifraude = action.payload.redesAntifraude;
        break;
      }
      case '@autenticacaoUsuarioRelatorio/AUTENTICAR': {
        draft.autenticandoPainelRelatorio = true;
        break;
      }
      case '@autenticacaoUsuarioRelatorio/DESAUTENTICAR': {
        draft.tokenPainelRelatorio = null;
        draft.autenticadoPainelRelatorio = false;
        break;
      }
      case '@autenticacaoUsuarioRelatorio/AUTENTICAR_SUCESSO': {
        draft.tokenPainelRelatorio = action.payload.tokenPainelRelatorio;
        draft.autenticadoPainelRelatorio = true;
        draft.autenticandoPainelRelatorio = false;
        break;
      }
      case '@autenticacaoUsuarioRelatorio/AUTENTICAR_FALHOU': {
        draft.autenticandoPainelRelatorio = false;
        break;
      }
      default:
    }
  });
}
